<!-- template for the modal component -->
<template type="x/template">
  <transition name="modal" id="contact-info-dialog">
    <div class="modal-mask" v-show="show">
      <div class="modal-container" @click.stop>
        <div class="modal-header">
          <h3>{{ $t('bulk_actions.parcel_group_change') }}</h3>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="form col-lg-5">
              <label class="control-label">{{$t("common.group")}}</label>
              <b-form-select
                  v-model="group_uuid"
                  class="form-control"
                  @change="onGroupChanged"
                  :class="{ 'field-error' : $v.group_uuid.$error }"
                  :options="group_list"></b-form-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 fw-bold">
              {{ $t('works.parcels.selected_parcels', { count: modalData.items?.length })}}
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 text-danger">
              {{ error }}
            </div>
          </div>
        </div>
        <div class="modal-footer col-lg-12">
          <div class="form-group row justify-content-end">
            <div class="col-lg-6">
              <button class="btn btn-outline-success" @click="OK()">{{$t("common.change")}}</button>
            </div>
            <div class="col-lg-6">
              <button class="modal-default-button btn btn-outline-secondary ml-3" @click="close()">{{$t("common.close")}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import {buildDropdownOptions} from "@/helpers/common";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'ParcelGroupChangeDialog',
  props: ['show', 'data'],
  data: function () {
    return {
      modalData: this.data,
      group_uuid: null,
      error: '',
    };
  },
  computed: {
    ...mapGetters({
        groups: "works-parcels/parcelGroups",
        parcelFilters: 'works-parcels/parcelFilters',
    }),
    group_list() {
      return buildDropdownOptions(this.groups, {
        value: 'uuid',
        text: 'name',
      }, {
        value: null,
        text: this.$t('works.parcels.select_group_to_apply'),
      });
    }
  },
  methods: {
    ...mapActions({
        getGroups: "works-parcels/getParcelGroups",
    }),
    close: function () {
      this.$emit('close');
    },
    OK () {
      this.$v.group_uuid.$touch();
      if(!this.$v.group_uuid.$invalid) {
        this.modalData.group_uuid = this.group_uuid;
        this.modalData.group_name = this.groups.find(g => g.uuid === this.group_uuid).name;
        this.$emit('onParcelGroupApplied', this.modalData);
        this.close();
      }
    },
    setErrorMessage(msg) {
      this.error = msg;
    },
    onGroupChanged(value) {
      this.$emit('onParcelGroupChanged', value);
    }
  },
  watch: {
    data: function(newVal) {
      this.modalData = newVal;
    },
    show: function(newVal) {
      this.setErrorMessage("");
    },
    parcelFilters: {
      handler: function(newVal) {
        this.getGroups({
          season_uuid: newVal.season_uuid,
        });
      },
      deep: true,
    }
  },
  validations() {
    return {
      group_uuid: {
        required,
      },
    }
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
</style>
